import { selectGameInfoError, selectOrganizer, selectSynchronization } from 'modules/stream/store/game-info/selectors';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import OverlayMessage from 'shared/components/overlay-message';
import { useFetchAvailableFeature } from 'shared/hooks/fetchering/use-fetch-available-feature';
import supabase from '../../../core/supabase/supabase';

import { CanvasEventBoards } from '../components/canvas/canvas-event-boards';
import { CanvasStaticBoards } from '../components/canvas/canvas-static-boards';
import Joystick from '../components/joystick/joystick';
import useInitOverlay from '../hooks/initializers/use-init-overlay';

function Overlay() {
  useInitOverlay();

  useEffect(() => {
    window.onerror = function (msg, url, line, col, error) {
      supabase.overlayLogs.createError({
        comment: 'overlay - общий',
        message: error?.stack ?? msg.toString(),
      });
    };
  }, []);

  const organizer = useSelector(selectOrganizer);
  const { isSynchronize: isOrganizerInfoFetched } = useSelector(selectSynchronization);
  const gameInfoError = useSelector(selectGameInfoError);

  const {
    data: feature,
    isLoading: isFeatureLoading,
    error: featureError,
  } = useFetchAvailableFeature({
    userTournamentId: organizer?.id,
    isEnabled: isOrganizerInfoFetched,
  });

  useEffect(() => {
    const rootDiv = document.getElementById('root');
    const body = document.getElementsByTagName('body')[0];
    rootDiv?.setAttribute('style', 'background: unset');
    body?.setAttribute('style', 'background: unset; overflow: hidden');
  }, []);

  if (gameInfoError) return <OverlayMessage variant={'error'} title={`Ошибка при получении информации о матче: ${gameInfoError}`} />;

  if (featureError)
    return <OverlayMessage variant={'error'} title={`Ошибка при получении подписки: ${(featureError as Error)?.message}`} />;

  if (isFeatureLoading || !isOrganizerInfoFetched)
    return <OverlayMessage title={'Загрузка, подождите'} subtitle={'При плохом соединении загрузка может занимать несколько минут'} />;

  if (!feature?.OBS_INTEGRATION && isOrganizerInfoFetched) {
    return <OverlayMessage variant={'error'} title={'Подписка не активирована'} />;
  }

  return (
    <div key={'overlay'} className={'flex justify-end'} style={{ width: '100%', height: '100vh' }}>
      <div
        className={'flex justify-end'}
        style={{
          background: 'unset',
          width: '100%',
          height: '100%',
          position: 'relative',
        }}
      >
        <CanvasStaticBoards />
        <CanvasEventBoards />
      </div>
      {feature?.OBS_INTEGRATION && <Joystick key={'FullSizeControlPanel-old'} />}
    </div>
  );
}

export default Overlay;
